module.exports = __webpack_public_path__ + "assets/img/34_879.dae2793c.jpg";